import { render, staticRenderFns } from "./jsList.vue?vue&type=template&id=24bd4538&"
import script from "./jsList.vue?vue&type=script&lang=js&"
export * from "./jsList.vue?vue&type=script&lang=js&"
import style0 from "./jsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "jsList.vue"
export default component.exports